import React from "react"
import Img from "gatsby-image"
import classnames from "classnames/bind"
// Style
import aboutStyle from "../../style/section/projectpage/about.module.scss"

const ProjectItem = props => pug`
  div.col-12.col-sm-6.col-md-3.pl-0(className=aboutStyle.item_block)
    div(className=aboutStyle.item_title)
      span.uppercase.text-gray-100=props.title
    div(className=aboutStyle.item_content)
      span.text-gray-200=props.content

`

function ProjectAbout(props) {
  return pug`
    div.projectAbout.flex.justify-center.items-center.flex-col(className=aboutStyle.wrapper)
      div(className=aboutStyle.about)
        div.col-12.col-md-8.px-0(className=aboutStyle.about_subtitle)
          span=props.subtitle
        div.col-12.col-md-8.px-0(className=aboutStyle.about_title)
          span=props.title
        div.col-12.px-0(className=aboutStyle.about_content)
          p.text-gray-200=props.content
      div.row(className=aboutStyle.item)
        ProjectItem(title="TIMELINE" content=props.timeline)
        ProjectItem(title="TYPE" content=props.type)
        ProjectItem(title="MY ROLE" content=props.role)
        ProjectItem(title="TOOLS USED" content=props.tool)
  `
}

export default ProjectAbout
